<template>
  <v-btn dark :block="block" :outlined="outlined" @click="logoutClicked">
    <v-icon dense left>mdi-logout</v-icon>
    Logout
  </v-btn>
</template>

<script>
import { mapActions } from "vuex";
import iziToast from "izitoast/dist/js/iziToast.min.js";

export default {
  props: {
    outlined: Boolean,
    block: Boolean,
  },
  methods: {
    ...mapActions("app", ["logout"]),
    async logoutClicked() {
      try {
        // Clear app state first so prior-user data cannot flash on next login
        await this.logout();

        try {
          await this.$authentication.signOut();
        } catch (signOutErr) {
          console.error("Amplify signOut error:", signOutErr);
        }

        this.$router.push({
          path: "/login",
          query: {
            redirect: "/",
          },
        });

        iziToast.success({
          title: "Success",
          message: "You have been logged out successfully",
        });
      } catch (err) {
        console.error("Logout error:", err);
        // Still force clear + login redirect if something fails mid-way
        try {
          await this.logout();
        } catch (e) {
          /* ignore */
        }
        this.$router.push({ path: "/login", query: { redirect: "/" } });
        iziToast.error({
          title: "Error",
          message: "An error occurred during logout. Please try again.",
        });
      }
    },
  },
};
</script>

<style></style>
